// Polyfill for browser compatibility
if (typeof process === 'undefined') {
  ;(window as any).process = {
    env: {}
  }
}

export {}
